import Vue from 'vue';
import violationPush from '../../components/violation-manage/violation-push.vue';
import violationQueryTrigger from '../../components/violation-manage/violation-query-trigger.vue';
import determineCost from '../../components/violation-manage/violation-determine-cost.vue';
import resultList from '../../components/violation-manage/vehicle-viloation-table.vue';
import btnImport from '../../components/console-common/export-btn.vue';
export default Vue.extend({
    name: 'violationQuery',
    components: {
        'el-violation-push': violationPush,
        'el-violation-query-trigger': violationQueryTrigger,
        'el-result-list': resultList,
        'el-export-button': btnImport,
        'el-determine-cost': determineCost,
    },
    computed: {
        exportParams: function () {
            var _a = this, queryType = _a.queryType, asyncKey = _a.asyncKey;
            var params = {
                type: queryType,
                orderCode: asyncKey,
                redisVehicleInfoCode: '',
            };
            if (this.queryType === 'UPLOAD') {
                params.redisVehicleInfoCode = this.uploadKey;
                return params;
            }
            delete params.redisVehicleInfoCode;
            return params;
        },
    },
    data: function () {
        return {
            isOpenPush: false,
            isPush: true,
            asyncKey: '',
            queryType: 'TENANT',
            uploadKey: '',
            otherParam: {},
            violationParams: {},
        };
    },
    created: function () {
        this.$store.dispatch('violationManage/GET_COSTCOUNT');
    },
    methods: {
        setPushStatus: function (params) {
            this.isOpenPush = params.isOpenPush;
        },
        setSwitchPush: function (params) {
            this.isPush = params.isPush;
        },
        getViolationParams: function (_a) {
            var violationParams = _a.violationParams;
            this.violationParams = violationParams;
        },
        getAsynckey: function (_a) {
            var asyncKey = _a.asyncKey;
            this.asyncKey = asyncKey;
            this.$store.dispatch('violationManage/GET_COSTCOUNT');
        },
        violationQuery: function () {
            this.otherParam = this.violationParams;
        },
        toPurchase: function () {
            this.$router.push({
                name: 'violationPurchase',
            });
        },
        openDetailMsg: function (url) {
            window.open(url);
        },
    },
});
